const selectedSectionAndPageReducer = (state = {}, action) => {
    switch (action.type) {
      case "SET_SELECTED_SECTION_AND_PAGE":
        return action.payload;
      default:
        return state;
    }
  }
  export default selectedSectionAndPageReducer;